import { FETCH_PRODUCTS_BY_CATEGORY, FLUSH_PRODUCTS, SET_IS_FETCHING_PRODUCTS } from 'reducers/actions-types';
import axios from 'axios';
import { dispatchError } from 'reducers/helpers';
import productsFactoryMiddleware from 'util/misc/products-factory-middleware';

let pendingRequestsCount = 0;

/**
 * Helper function that will set the isFetching flag to false or true if there are still loading requests in the queue
 * @param { funciton } dispatch - redux dispatch function
 */
function setIsFetching(dispatch) {
    pendingRequestsCount--;
    const isFetching = pendingRequestsCount !== 0;
    dispatch({ type: SET_IS_FETCHING_PRODUCTS, isFetching });
}

/**
 * Fetch the products depending on the category
 * @param {ICategory} category
 * @return {Promise<IProduct[]>}
 */
function fetchProductsByCategory({ category }) {
    pendingRequestsCount++;
    return axios.get(category.products_url)
        .then(({ data }) => {
            return data;
        });
}

export default Object.freeze({
    /**
     * @param {ICategory} category
     * @return {function: Promise<ICooperativeProduct[]>}
     */
    fetchProductsByCategory({ category }) {
        return function(dispatch, getState) {
            const cooperative = getState().router.cooperative;
            dispatch({ type: SET_IS_FETCHING_PRODUCTS, isFetching: true });
            return fetchProductsByCategory({
                category,
            })
                .then(
                    /**
                     *
                     * @param {IProduct[]} products
                     * @return {ICooperativeProduct[]}
                     */
                    products => productsFactoryMiddleware(products, { cooperative }))
                .then(
                    /**
                     * @param {ICooperativeProduct[]} products
                     * @return {ICooperativeProduct[]}
                     */
                    products => {
                        setIsFetching(dispatch);
                        dispatch({ type: FETCH_PRODUCTS_BY_CATEGORY, products, category, cooperative });
                        return products;
                    })
                .catch(e => {
                    setIsFetching(dispatch);

                    if (e.status === 404) {
                        return Promise.reject(e);
                    }

                    dispatchError(dispatch, e, {
                        url: category.products_url,
                        description: e.message,
                    });

                    dispatch({
                        type: FETCH_PRODUCTS_BY_CATEGORY,
                        products: [],
                        category,
                    });

                    return Promise.resolve([]);
                });
        };
    },
    flush() {
        return { type: FLUSH_PRODUCTS };
    },
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/products/actions.js